(function(){
function raptorPdp(){
  var meta = document.querySelector('.product-single__meta');
  if (!meta || meta.getAttribute('data-raptor')) return;
  meta.setAttribute('data-raptor', '1');
  document.body.classList.add('raptor-pdp');
  var title = meta.querySelector('.product-single__title');
  var name = title ? title.textContent.trim() : '';
  var grid = meta.closest('.grid');
  if (grid) {
    var bc = document.createElement('nav');
    bc.className = 'rp-breadcrumb';
    bc.setAttribute('aria-label', 'Breadcrumb');
    bc.innerHTML = '<a href="/">Home</a><span>/</span><a href="/collections/all">Shop All</a><span>/</span><b></b>';
    bc.querySelector('b').textContent = name;
    grid.parentNode.insertBefore(bc, grid);
  }
  if (title) {
    var tag = document.createElement('div');
    tag.className = 'rp-tag';
    tag.textContent = 'Real Cow Leather';
    title.parentNode.insertBefore(tag, title);
  }
  var price = meta.querySelector('.product__price');
  if (price) {
    var row = document.createElement('div');
    row.className = 'rp-price-row';
    price.parentNode.insertBefore(row, price);
    row.appendChild(price);
    var pill = document.createElement('span');
    pill.className = 'rp-pill';
    pill.textContent = 'Free Delivery';
    row.appendChild(pill);
  }
  var buttons = meta.querySelector('.payment-buttons');
  if (buttons) {
    var info = document.createElement('div');
    info.className = 'rp-eta';
    info.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/></svg><span>Your wallet reaches you in <b>3 to 5 days</b>. You pay cash to the rider.</span>';
    buttons.parentNode.insertBefore(info, buttons.nextSibling);
    var check = document.createElement('div');
    check.className = 'rp-check';
    check.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg><div><b>Open and check before you pay</b><span>When the rider comes, open the box and look at your wallet. If you like it, pay the rider. If not, give it back.</span></div>';
    buttons.parentNode.insertBefore(check, info);
    var trust = document.createElement('div');
    trust.className = 'rp-trust';
    var items = [
      ['M3 7h11v9H3zM14 10h4l3 3v3h-7z', 'Free Delivery', 'On every order'],
      ['M3 6h18v12H3zM3 10h18', 'COD', 'Cash on Delivery'],
      ['M12 3l8 4v5c0 5-4 8-8 9-4-1-8-4-8-9V7z', 'Real Leather', 'Strong and soft'],
      ['M4 12a8 8 0 0 1 14-5M20 12a8 8 0 0 1-14 5M18 3v4h-4M6 21v-4h4', 'Easy Exchange', 'Within 7 days']
    ];
    items.forEach(function(it){
      var d = document.createElement('div');
      d.className = 'rp-trust__item';
      d.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="' + it[0] + '"/></svg><div><b>' + it[1] + '</b><small>' + it[2] + '</small></div>';
      trust.appendChild(d);
    });
    info.parentNode.insertBefore(trust, info.nextSibling);
    var form = meta.querySelector('.product-single__form');
    var bar = document.createElement('div');
    bar.className = 'rp-sticky';
    var img = document.querySelector('.product__main-photos img, .product-main-slide img, .product-single__media img');
    bar.innerHTML = '<div class="rp-sticky__info"><img alt=""><div><span class="rp-sticky__name"></span><span class="rp-sticky__price"></span></div></div><button type="button" class="rp-sticky__btn">ORDER NOW</button>';
    var bimg = bar.querySelector('img');
    if (img) { bimg.src = img.currentSrc || img.src || ''; } else { bimg.remove(); }
    bar.querySelector('.rp-sticky__name').textContent = name;
    function syncPrice(){ if (price) bar.querySelector('.rp-sticky__price').textContent = price.textContent.trim(); }
    syncPrice();
    document.body.appendChild(bar);
    bar.querySelector('.rp-sticky__btn').addEventListener('click', function(){
      var pay = document.querySelector('.shopify-payment-button__button');
      if (pay) { pay.click(); return; }
      if (form) {
        var r = form.querySelector('input[name="return_to"]');
        if (!r) { r = document.createElement('input'); r.type = 'hidden'; r.name = 'return_to'; form.appendChild(r); }
        r.value = '/checkout';
        form.submit();
      }
    });
    function onScroll(){
      var anchor = buttons.querySelector('.shopify-payment-button') || buttons.querySelector('.add-to-cart') || buttons;
      var rect = anchor.getBoundingClientRect();
      bar.classList.toggle('is-visible', rect.bottom < 0);
      syncPrice();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', raptorPdp); } else { raptorPdp(); }
})();
(function(){
  var og = document.querySelector('meta[property="og:image"]');
  var img = document.querySelector('.rp-sticky__info img');
  if (og && img) { img.src = og.content.replace(/^http:/, 'https:'); }
})();
